var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ButtonPrimary, ButtonSecondary, ButtonTertiary, } from '@spotify-internal/encore-web';
import { FrodorModulesContext } from '../../../Context';
import styled from 'styled-components';
export const Link = (_a) => {
    var { href, openInNewTab, trackingLabel, trackingCategory, variant = 'a', children } = _a, rest = __rest(_a, ["href", "openInNewTab", "trackingLabel", "trackingCategory", "variant", "children"]);
    const { getLinkProps } = useContext(FrodorModulesContext);
    const linkProps = getLinkProps
        ? getLinkProps({
            trackingAttributes: [trackingCategory, trackingLabel, 'click'],
            href,
            openInNewTab,
        })
        : { href, target: openInNewTab ? '_blank' : '_self' };
    switch (variant) {
        case 'buttonPrimary':
            return (React.createElement(ButtonPrimary, Object.assign({}, linkProps, rest), children));
        case 'buttonSecondary':
            return (React.createElement(ButtonSecondary, Object.assign({}, linkProps, rest), children));
        default:
        case 'buttonTertiary':
            return (React.createElement(ButtonTertiary, Object.assign({}, linkProps, rest), children));
        case 'a':
            if (!linkProps.href) {
                return (React.createElement("button", Object.assign({}, linkProps, rest), children));
            }
            return (React.createElement("a", Object.assign({}, linkProps, rest), children));
    }
};
export const ButtonPrimaryLink = (_a) => {
    var link = __rest(_a, []);
    return (React.createElement(Link, Object.assign({}, link, { variant: "buttonPrimary" }), link.label));
};
export const ButtonSecondaryLink = (_a) => {
    var link = __rest(_a, []);
    return (React.createElement(Link, Object.assign({}, link, { variant: "buttonSecondary" }), link.label));
};
export const ButtonTertiaryLink = (_a) => {
    var link = __rest(_a, []);
    return (React.createElement(Link, Object.assign({}, link, { variant: "buttonTertiary" }), link.label));
};
const ImageLinkWrapper = styled(Link) `
  > img {
    width: 100%;
  }
`;
export const ImageLink = (_a) => {
    var imageLink = __rest(_a, []);
    return (React.createElement(ImageLinkWrapper, Object.assign({}, imageLink.link),
        React.createElement("img", { src: imageLink.image.file.url, alt: imageLink.altText })));
};
//# sourceMappingURL=Link.js.map